"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatNumber(locale = 'en-US', formatOptions = {}, amount) {
    if (isNaN(Number(amount))) {
        return '';
    }
    const code = (typeof locale === 'string' ? locale : locale.intlCode) || 'en-US';
    const formatter = new Intl.NumberFormat(code, formatOptions);
    return formatter.format(Number(amount));
}
exports.formatNumber = formatNumber;
//# sourceMappingURL=format-number.js.map